import { motion } from 'framer-motion';
import { Button } from '@educa-legal/ui';

export function Hero() {
  return (
    <section className="relative isolate min-h-[640px] md:min-h-[720px] lg:min-h-[760px] overflow-hidden">
      {/* Foto background — Ken Burns sutil na entrada */}
      <motion.div
        className="absolute inset-0"
        initial={{ opacity: 0, scale: 1.05 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.2, ease: 'easeOut' }}
      >
        <img
          src="/foto-hero-bg.webp"
          alt="Pedro Guimarães Neto — fundador da Educa Legal"
          className="h-full w-full object-cover object-[78%_center] md:object-[right_center]"
          loading="eager"
          fetchPriority="high"
          width={2400}
          height={1350}
        />
      </motion.div>

      {/* Overlay 1 — gradiente lateral (escuro à esquerda, transparente à direita) */}
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-r from-neutral-950/90 via-neutral-950/70 to-neutral-950/20 md:via-neutral-950/55 md:to-transparent"
      />

      {/* Overlay 2 — escurecimento sutil no rodapé (para o crédito) */}
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-neutral-950/30"
      />

      {/* Conteúdo (acima dos overlays via ordem do DOM + position relative) */}
      <div className="section-container relative z-10 flex items-center min-h-[640px] md:min-h-[720px] lg:min-h-[760px] pt-28 pb-20 md:pt-32 md:pb-24 lg:pt-36">
        <div className="max-w-2xl">
          {/* Eyebrow editorial */}
          <motion.div
            className="flex items-center gap-3 mb-7"
            initial={{ opacity: 0, x: -16 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.55, ease: 'easeOut' }}
          >
            <motion.span
              className="h-px bg-orange origin-left"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.6, delay: 0.1, ease: 'easeOut' }}
              style={{ width: 40 }}
            />
            <span className="text-caption font-semibold uppercase tracking-[0.22em] text-orange-300">
              Educa Legal — Consultoria Jurídica para Escolas
            </span>
          </motion.div>

          {/* H1 — único na página */}
          <motion.h1
            className="text-display-lg md:text-display-xl lg:text-display-2xl font-bold text-white leading-[1.05] tracking-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.65, delay: 0.15 }}
          >
            Sua escola merece um jurídico que entende o seu negócio.
          </motion.h1>

          {/* H2 — subtítulo com SEO */}
          <motion.h2
            className="mt-6 md:mt-7 text-body-lg md:text-xl text-neutral-200 leading-relaxed font-normal max-w-xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.65, delay: 0.25 }}
          >
            A Educa Legal oferece assessoria jurídica especializada para escolas e instituições
            de ensino — acessível, estratégica e direta. Somos o parceiro que sua gestão escolar
            precisa para antecipar riscos, resolver conflitos e focar no que realmente importa:
            oferecer educação de qualidade.
          </motion.h2>

          {/* CTAs */}
          <motion.div
            className="mt-10 flex flex-col sm:flex-row gap-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.65, delay: 0.45 }}
          >
            <Button asChild variant="primary" size="lg">
              <a href="https://wa.me/5511989082892" target="_blank" rel="noopener noreferrer">
                Fale com a Educa Legal
              </a>
            </Button>
            <Button asChild variant="outline-white" size="lg">
              <a href="#servicos">Ver serviços</a>
            </Button>
          </motion.div>
        </div>
      </div>

      {/* Crédito discreto no canto inferior direito (oculto em mobile) */}
      <motion.div
        className="absolute bottom-6 right-8 md:bottom-8 md:right-14 lg:right-20 z-10 hidden sm:flex items-start gap-3 text-right"
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.6 }}
      >
        <span aria-hidden className="mt-2 h-px w-6 bg-orange flex-shrink-0" />
        <div>
          <div className="text-body-sm font-semibold text-white leading-snug">
            Pedro Guimarães Neto
          </div>
          <div className="text-caption uppercase tracking-widest text-neutral-300 mt-0.5">
            Fundador
          </div>
        </div>
      </motion.div>
    </section>
  );
}
